import { BehaviorSubject } from 'rxjs';

export interface IIntervalData {
    id: number;
    interval: number;
    intervalSubject: BehaviorSubject<number>;
}

export interface ITimerItem {
    id: number;
    subject: BehaviorSubject<number>;
    stop: () => void;
    fire: () => void;
}

const getInterval = (id: number) => {
    return intervals.find((int) => {
        return int.id === id;
    });
};

const deleteInterval = (id: number) => {
    getInterval(id)?.intervalSubject?.unsubscribe();
    intervals = intervals.filter((int) => {
        return int.id !== id;
    });
};

const getUniqueId = () => {
    let uniqueId = new Date().getTime();
    while (getInterval(uniqueId)) {
        uniqueId++;
    }
    return uniqueId;
};


// Stores the interval data
let intervals: IIntervalData[] = [];

export const startTimer = (interval: number, fireNow: boolean = false) => {
    const intervalId = getUniqueId();
    const intervalSubject: BehaviorSubject<number> = new BehaviorSubject<number>(-1);

    intervals.push({
        id: intervalId,
        interval: interval,
        intervalSubject: intervalSubject
    });

    if (fireNow) {
        const interval = intervals[intervals.length - 1];
        interval.intervalSubject.next(interval.id);
    }

    timeoutTimer(intervalId);

    return {
        id: intervalId,
        subject: intervals[intervals.length - 1].intervalSubject,
        stop: () => stopTimer(intervalId),
        fire: () => fireTimer(intervalId),
    } as ITimerItem;
};

// Stop an interval
export const stopTimer = (id: number) => {
    deleteInterval(id);
};

export const fireTimer = (id: number) => {
    getInterval(id)?.intervalSubject.next(id);
};

// Create an infinite timeout loop
export const timeoutTimer = (id: number) => {
    const interval = getInterval(id);
    if (interval) {
        setTimeout(() => {
            const interval = getInterval(id);
            if (interval) {
                interval.intervalSubject.next(interval.id);
                timeoutTimer(id);
            }
        }, interval.interval);
    }
};

export const syncTimer = startTimer(1000);
export const slowTimer = startTimer(10000, true);
